module.exports = __webpack_public_path__ + "iconmonstr-youtube-6-48.png?6353b0253bf7d35bd07cf92b394ef343";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconmonstr-youtube-6-48.png
// module id = 91
// module chunks = 0